export enum BookingStatus {
    IN_PROGRESS = 'IN_PROGRESS',
    SUCCESS = 'SUCCESS',
    RETRY = 'RETRY',
    ERROR = 'ERROR',
}

export enum ErrorReason {
    BOOKING_FAILED = 'booking-failed',
    BOOKING_WITHOUT_PAYMENT_FAILED = 'booking-without-payment-failed',
    PAYMENT_FAILED = 'payment-failed',
    RESERVATION_EXPIRED = 'reservation-expired',
}

export enum BookingFlow {
    STANDARD_BOOKING = 'STANDARD_BOOKING',
    NON_PAYMENT_BOOKING = 'NON_PAYMENT_BOOKING',
}
